import type { ReactNode } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTopButton from "@/components/feature/ScrollToTopButton";
import { useScrollToTop } from "@/hooks/useScrollToTop";

export default function Layout({ children }: { children: ReactNode }) {
  useScrollToTop();
  return (
    <div className="min-h-screen flex flex-col bg-background-950">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <ScrollToTopButton />
    </div>
  );
}